import { render, staticRenderFns } from "./SavedArtworksBar.vue?vue&type=template&id=5ac2aeab&scoped=true"
import script from "./SavedArtworksBar.vue?vue&type=script&lang=js"
export * from "./SavedArtworksBar.vue?vue&type=script&lang=js"
import style0 from "./SavedArtworksBar.vue?vue&type=style&index=0&id=5ac2aeab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2aeab",
  null
  
)

export default component.exports